import { render, staticRenderFns } from "./menu3_video_clip.vue?vue&type=template&id=658cf896&scoped=true"
import script from "./menu3_video_clip.vue?vue&type=script&lang=js"
export * from "./menu3_video_clip.vue?vue&type=script&lang=js"
import style0 from "./menu3_video_clip.vue?vue&type=style&index=0&id=658cf896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658cf896",
  null
  
)

export default component.exports